import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedItemAutorizarComponent {
  autorizado
  autorizando = false
  indice
  importe
  solicitudId
  data = {}
  onClose

  constructor (ViaticosAutorizacionService) {
    this.ViaticosAutorizacionService = ViaticosAutorizacionService
  }

  $onInit () {
    this.maximo = this.importe
  }

  confirmar () {
    this.autorizando = true
    this.ViaticosAutorizacionService.put(this.solicitudId, this.indice, this.importe)
      .then(({data}) => (this.cerrar(data)))
      .finally(() => (this.autorizando = false))
  }

  cerrar (data) {
    this.autorizando = false
    this.onClose({$event: {detail: data}})
  }
}

module.component('viaticosSharedItemAutorizar', {
  controller: ViaticosSharedItemAutorizarComponent,
  template,
  bindings: {
    autorizado: '<',
    indice: '<',
    importe: '<',
    solicitudId: '<',
    onClose: '&',
  },
})




// WEBPACK FOOTER //
// ./src/viaticos/components/shared/item/autorizar/component.js